import { c as _c } from "react/compiler-runtime";
import { MonetizableStarRatingTooltip, type StarRatingTooltipProps } from './Monetizable';
import { NotMonetizableStarRatingTooltip } from './NotMonetizable';
export function StarRatingTooltip(t0) {
  const $ = _c(3);
  const {
    isMonetizing,
    segmentActionSection
  } = t0;
  let t1;
  if ($[0] !== isMonetizing || $[1] !== segmentActionSection) {
    t1 = isMonetizing ? <MonetizableStarRatingTooltip segmentActionSection={segmentActionSection} /> : <NotMonetizableStarRatingTooltip segmentActionSection={segmentActionSection} />;
    $[0] = isMonetizing;
    $[1] = segmentActionSection;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}